import { createApi } from "@reduxjs/toolkit/query/react";

import apiConfig from "configs/apiConfig";
import { REDUCER_PATHS } from "store/config";
import {
  transformConfigurationResponseHandler,
  transformResponseHandler,
} from "utils/transformResponseHandler";

import { customFetchBase } from ".";

const profileApi = createApi({
  reducerPath: REDUCER_PATHS.PROFILE,
  baseQuery: customFetchBase,
  tagTypes: ["Profile"],
  endpoints: (builder) => ({
    profile: builder.query({
      query: () => ({
        url: apiConfig.PROFILE,
        method: "GET",
      }),
      providesTags: ["Profile"],
      transformResponse: (resp) => transformResponseHandler(resp, false),
    }),
    editProfile: builder.mutation({
      query: (data) => ({
        url: apiConfig.EDIT_PROFILE,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Profile"],
      transformResponse: (resp) => transformResponseHandler(resp),
    }),
    changePassword: builder.mutation({
      query: (data) => ({
        url: apiConfig.CHANGE_PASSWORD,
        method: "POST",
        body: data,
      }),
      transformResponse: (resp) => transformResponseHandler(resp),
    }),
    imageUpload: builder.mutation({
      query: (data) => ({
        url: apiConfig.IMAGE_UPLOAD,
        method: "POST",
        body: data,
      }),
      transformResponse: (resp) => transformResponseHandler(resp),
    }),
    fileUpload: builder.mutation({
      query: (data) => ({
        url: apiConfig.FILE_UPLOAD,
        method: "POST",
        body: data,
      }),
      transformResponse: (resp) => transformConfigurationResponseHandler(resp),
    }),
    fileUploadMultiple: builder.mutation({
      query: (data) => ({
        url: `${apiConfig.MULTIPLE_FILE_UPLOAD}/${data?.module}`,
        method: "POST",
        body: data?.data,
      }),
      transformResponse: (resp) => transformResponseHandler(resp),
    }),
    fileUploadMultipleVideo: builder.mutation({
      query: (data) => ({
        url: `${apiConfig.MULTIPLE_VIDEO_UPLOAD}/${data?.module}`,
        method: "POST",
        body: data?.data,
      }),
      transformResponse: (resp) => transformResponseHandler(resp),
    }),
    fileUploadMultipleDocument: builder.mutation({
      query: (data) => ({
        url: `${apiConfig.MULTIPLE_DOCUMENT_UPLOAD}/${data?.module}`,
        method: "POST",
        body: data?.data,
      }),
      transformResponse: (resp) => transformResponseHandler(resp),
    }),
    globalConfig: builder.query({
      query: () => ({
        url: apiConfig.GLOBAL_CONFIG,
        method: "GET",
      }),
      providesTags: ["Profile"],
    }),
    deleteProfile: builder.mutation({
      query: (data) => ({
        url: apiConfig.DELETE_PROFILE,
        method: "DELETE",
        body: data,
      }),
      transformResponse: (resp) => transformResponseHandler(resp),
    }),
  }),
});

export const {
  useProfileQuery,
  useEditProfileMutation,
  useChangePasswordMutation,
  useImageUploadMutation,
  useFileUploadMutation,
  useGlobalConfigQuery,
  useDeleteProfileMutation,
  useFileUploadMultipleMutation,
  useFileUploadMultipleVideoMutation,
  useFileUploadMultipleDocumentMutation,
} = profileApi;

export default profileApi;
